module.exports = __webpack_public_path__ + "img/vu.1c3366c8.svg";